<div class="punchlist-row-block">
  <div class="punchlist-row" *ngFor="let checkItem of tempTask.checkitems; let i = index">

    <div class="check-item-row" *ngIf="!(editItem === checkItem.id)" [class.checked-checkitem]="checkItem.ready">
      <div class="punch-item-block">
        <div class="check-item-index" *ngIf="tempTask.checkitems?.length > 2">{{i + 1}}</div>
        <div class="check-icon" (click)="toggleReady(checkItem)"
             [ngClass]="{'has-tags': checkItem.tags?.length > 0}">
          <mat-icon>done</mat-icon>
        </div>
        <div class="punchlist-checkitem-title-tags" (click)="editCheckItem(checkItem)">
          <div class="punchlist-checkitem-title">
            <span class="pre-wrap" appUserMentionContent [content]="checkItem.name"
                  [mentions]="checkItem.mentions">{{checkItem.name}}</span>
            <div *ngIf="loadingSpinnerId === checkItem.id" class="loading-block-spinner">
              <mat-spinner></mat-spinner>
            </div>
            <i class="pi pi-paperclip" style="font-size: 100%" *ngIf="checkItem.files?.length > 3"></i>
            <ng-container *ngIf="checkItem.files?.length <= 3">
              <i class="pi pi-paperclip" style="font-size: 100%" *ngFor="let file of checkItem.files"
                 (click)="openFile($event, file, checkItem)"></i>
            </ng-container>
          </div>

          <div class="punchlist-tags" *ngIf="checkItem.tags?.length > 0">
            <div class="punchlist-tag {{tag?.type?.title}}-tag" *ngFor="let tag of checkItem.tags"
                 (click)="toggleTag($event, tag)"
                 [ngClass]="{'ready-tag': tag.ready, 'sent-tag': tag.sentDate, 'missed-tag': tag.name === 'Amount' && !tag.invoiceId, 'disabled-tag': isTagDisabled(tag)}">
              <span class="tag-span">
                {{tag?.type?.title}}
                <span *ngIf="tag.name === 'Amount'">
                  <span *ngIf="!tag.sentDate && !tag.ready"> - Not Sent</span>
                  <span *ngIf="tag.sentDate && !tag.ready"> - Not Paid</span>
                  <span *ngIf="!tag.invoiceId && !tag.ready"> - Missing</span>
                  <span *ngIf="tag.ready"> - Paid</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="edit-punch-item-block" *ngIf="editItem === checkItem.id">
      <app-edit-task-checkitem [checkItem]="checkItem" [projectId]="projectId" (updateAction)="onUpdateItem($event)"
                               (deleteAction)="deleteCheckItem(checkItem)" (closeAction)="onEditBlockClosed()"
                               [users]="users"
                               [tags]="tags"
                               [canEditText]="canEditCheckitemText()">
      </app-edit-task-checkitem>
    </div>
  </div>
</div>


<button mat-button class="show-input-button" (click)="openEditor()" *ngIf="tempTask.clazz === 'SERVICE_ORDER_TASK'">
  <mat-icon>edit</mat-icon>
  <div class="button-title">Edit</div>
</button>

<input class="mobile-photo-input" type="file" capture="camera" id="cameraInput" name="cameraInput"
       (change)="onFileSelected($event)">

<!-- <div class="new-punch-item-block" *ngIf="editItem < 0">
	<button mat-button class="show-input-button" (click)="addCheckItem(checkList)" *ngIf="editItem === -1">
		<mat-icon>add</mat-icon>
		<div class="button-title">Add new check item</div>
	</button>

	<app-add-task-checkitem [checkList]="checkList" (closeAction)="onEditBlockClosed()"
		*ngIf="editItem === -2 && checkListForAdd === checkList.id">
	</app-add-task-checkitem>
</div> -->
